import { Textarea, Text, Flex } from '@chakra-ui/react';

import ModifierLabel from './ModifierLabel';

import * as fp from 'lodash/fp';

const TEXT_LIMIT = 100;

type NoteInputSectionProps = {
  note: string;
  onChangeNote: (note: string | ((prev: string) => string)) => void;
};

export default function NoteInputSection({ note, onChangeNote }: NoteInputSectionProps) {
  return (
    <Flex direction="column">
      <ModifierLabel title={'餐點備註'} description={'餐點特別需求備註(比如：不要加香菜)'} />

      <Flex direction="column" py={2}>
        <Textarea
          _focus={{}}
          borderColor="gray.400"
          fontSize="xs"
          resize="none"
          value={note}
          onChange={(e) =>
            fp.lte(e.target.value.length, TEXT_LIMIT) && onChangeNote(e.target.value)
          }
        />
        <Text textAlign="end" fontSize="xs" color="gray.400">
          ({note.length}/{TEXT_LIMIT})
        </Text>
      </Flex>
    </Flex>
  );
}
